import { LoaderCircle, TriangleAlert } from "lucide-react";

export function ListLoading({ label }: { label: string }) {
  return (
    <output className="list-state">
      <LoaderCircle
        className="shell-state__spinner list-state__icon"
        size={40}
        strokeWidth={1.6}
        aria-hidden="true"
      />
      <p className="list-state__hint">{label}</p>
    </output>
  );
}

export function ListError({ message, onRetry }: { message: string; onRetry: () => void }) {
  return (
    <div className="list-state">
      <TriangleAlert size={40} strokeWidth={1.6} className="list-state__icon" aria-hidden="true" />
      <h3 className="list-state__title">No se pudo cargar</h3>
      <p className="list-state__hint">{message}</p>
      <button type="button" className="btn" onClick={onRetry}>
        Reintentar
      </button>
    </div>
  );
}
